"use client";

import { Header, Footer } from "@/pages/landing/components";
import { cn } from "@/lib/utils";
import { useTranslation } from "react-i18next";

function PrivacyPolicyPage() {
  const { t } = useTranslation();

  return (
    <div className="bg-lavender-light w-full">
      <div
        className={cn(
          "flex flex-col min-h-screen max-w-7xl mx-auto",
          "2k:max-w-[80%]",
          "4k:max-w-[80%]"
        )}
      >
        <Header />
        <main className="px-6 md:px-14 py-12 md:py-20 grow">
          <h1 className="font-h1 mb-8">{t("legal.privacy.title")}</h1>
          <p className="text-sm text-muted-foreground mb-12">
            {t("legal.privacy.lastUpdated", { date: "2026-03-19" })}
          </p>

          <div className="prose prose-neutral max-w-3xl space-y-8">
            <section>
              <h2 className="font-h3 mb-3">{t("legal.privacy.sections.intro.title")}</h2>
              <p className="font-body text-muted-foreground">
                {t("legal.privacy.sections.intro.content")}
              </p>
            </section>

            <section>
              <h2 className="font-h3 mb-3">{t("legal.privacy.sections.collect.title")}</h2>
              <p className="font-body text-muted-foreground">
                {t("legal.privacy.sections.collect.content")}
              </p>
            </section>

            <section>
              <h2 className="font-h3 mb-3">{t("legal.privacy.sections.use.title")}</h2>
              <p className="font-body text-muted-foreground">
                {t("legal.privacy.sections.use.content")}
              </p>
            </section>

            <section>
              <h2 className="font-h3 mb-3">{t("legal.privacy.sections.sharing.title")}</h2>
              <p className="font-body text-muted-foreground">
                {t("legal.privacy.sections.sharing.content")}
              </p>
            </section>

            <section>
              <h2 className="font-h3 mb-3">{t("legal.privacy.sections.thirdParty.title")}</h2>
              <p className="font-body text-muted-foreground">
                {t("legal.privacy.sections.thirdParty.content")}
              </p>
            </section>

            <section>
              <h2 className="font-h3 mb-3">{t("legal.privacy.sections.storage.title")}</h2>
              <p className="font-body text-muted-foreground">
                {t("legal.privacy.sections.storage.content")}
              </p>
            </section>

            <section>
              <h2 className="font-h3 mb-3">{t("legal.privacy.sections.cookies.title")}</h2>
              <p className="font-body text-muted-foreground">
                {t("legal.privacy.sections.cookies.content")}
              </p>
            </section>

            <section>
              <h2 className="font-h3 mb-3">{t("legal.privacy.sections.rights.title")}</h2>
              <p className="font-body text-muted-foreground">
                {t("legal.privacy.sections.rights.content")}
              </p>
            </section>

            <section>
              <h2 className="font-h3 mb-3">{t("legal.privacy.sections.children.title")}</h2>
              <p className="font-body text-muted-foreground">
                {t("legal.privacy.sections.children.content")}
              </p>
            </section>

            <section>
              <h2 className="font-h3 mb-3">{t("legal.privacy.sections.changes.title")}</h2>
              <p className="font-body text-muted-foreground">
                {t("legal.privacy.sections.changes.content")}
              </p>
            </section>

            <section>
              <h2 className="font-h3 mb-3">{t("legal.privacy.sections.contact.title")}</h2>
              <p className="font-body text-muted-foreground">
                {t("legal.privacy.sections.contact.content")}
              </p>
            </section>
          </div>
        </main>
      </div>
      <Footer />
    </div>
  );
}

export default PrivacyPolicyPage;
